import clsx from 'clsx';
import { HTMLAttributes, ReactNode } from 'react';
interface BoxProps extends HTMLAttributes<HTMLDivElement> {
  className: string;
  style?: Record<string, any>;
  shape: 'circle' | 'square';
  children?: ReactNode;
}
const Box = ({ className, style, children, shape }: BoxProps): JSX.Element => {
  return (
    <div
      className={clsx(
        'flex justify-center items-center',
        {
          'rounded-full': shape === 'circle',
          'aspect-square': shape === 'square',
        },
        className,
      )}
      style={style ?? {}}
    >
      {children}
    </div>
  );
};

export default Box;
